<template>
  <div class="options__wrapper" v-if="currentProductInPopup && currentProductInPopup.product_options && currentProductInPopup.product_options.length">
    <template  v-for="option in currentProductInPopup.product_options" :key="option.id">
      <div class="option">
        <!-- v-if="option.show_type_kiosk != 'steps'" -->
        <div class="optionTitle">
          <p>{{option.name}}</p>
          <div class="minMax" v-if="option.type == 'radio' && option.values.length > 1 && option.required">
            <svg xmlns="http://www.w3.org/2000/svg" width="19.083" height="19.083" viewBox="0 0 19.083 19.083">
                <path id="Path_49" data-name="Path 49" d="M10.542,2a8.542,8.542,0,1,0,8.542,8.542A8.542,8.542,0,0,0,10.542,2Zm0,4.271a.854.854,0,0,1,.854.854V11.4a.854.854,0,0,1-1.708,0V7.125A.854.854,0,0,1,10.542,6.271Zm0,6.833a.854.854,0,1,1-.854.854A.854.854,0,0,1,10.542,13.1Z" transform="translate(-1 -1)" fill="#acacac" stroke="rgba(251,167,9,0)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              </svg>
              <div>
                <span>{{$t('addOrder.selectMinMax')}}</span> 
                <span>{{$t('addOrder.selectMin')}} 1</span> 
              </div>
          </div>
          <div class="minMax" v-if="option.min_no || option.max_no">
            <svg xmlns="http://www.w3.org/2000/svg" width="19.083" height="19.083" viewBox="0 0 19.083 19.083">
                <path id="Path_49" data-name="Path 49" d="M10.542,2a8.542,8.542,0,1,0,8.542,8.542A8.542,8.542,0,0,0,10.542,2Zm0,4.271a.854.854,0,0,1,.854.854V11.4a.854.854,0,0,1-1.708,0V7.125A.854.854,0,0,1,10.542,6.271Zm0,6.833a.854.854,0,1,1-.854.854A.854.854,0,0,1,10.542,13.1Z" transform="translate(-1 -1)" fill="#acacac" stroke="rgba(251,167,9,0)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              </svg>
              <div>
                <span>{{$t('addOrder.selectMinMax')}}</span> 
                <span v-if="option.min_no">{{$t('addOrder.selectMin')}} {{option.min_no}}</span> 
                <span v-if="option.max_no">{{$t('addOrder.selectMax')}} {{option.max_no}}</span>
              </div>
          </div>
        </div>
        <div :class="[
            'options',
            option.show_type_kiosk == 'default' ? 'withPhoto' : ''
          ]">
          <div v-for="(values, keyVal) in option.values" :key="values.id" 
          :class="[
            option.show_type_kiosk == 'default' ? 'withPhoto' : 'defaultOption'
          ]">
            <label :for="values.id">
              <template v-if="(option.type === 'checkbox')">
                <input :type="option.type"
                    :ref="'ref_' + values.id"
                    :name="option.id"
                    :disabled="values.disabled"
                    :value="values.id"
                    :id="values.id"
                    @change="updateCategories(option.id, values.id)"
                    v-model="values.checked"
              >
              <button @click="clickOnRef('ref_' + values.id)" :class="values.disabled ? 'disabled' : ''">
                <template v-if="option.show_type_kiosk == 'default'">
                  <div class="opt_photo" :style="'background-image: url('+option.values[keyVal].image+');'" ></div>
                </template>
                <span class="name">{{values.name}}</span>
                <template v-if="!currentProductInPopup.use_price_to_show">
                  <span class="price" v-if="values.price > 0" v-html="'+ ' + values.price + ' ' + currentProductInPopup.price_details.currency_symbol"></span>
                </template>
              </button>
              </template>
              <template v-else>
                <input :type="option.type"
                    :ref="'ref_' + values.id"
                    :name="option.id"
                    :value="values.id"
                    :id="values.id"
                    @change="updateCategories(option.id, values.id)"
                    v-model="option.checked"
              >
              <button @click="clickOnRef('ref_' + values.id)">
                <template v-if="option.show_type_kiosk == 'default'">
                  <div class="opt_photo" :style="'background-image: url('+option.values[keyVal].image+');'" ></div>
                </template>
                <span class="name">{{values.name}}</span>
                <template v-if="!currentProductInPopup.use_price_to_show">
                  <span class="price" v-if="values.price > 0" v-html="'+ ' + values.price + ' ' + currentProductInPopup.price_details.currency_symbol"></span>
                </template>
              </button>
              </template>

              <!-- <span>{{values.name}} <span v-if="values.price > 0">(+ {{values.price}} {{currentProductInPopup.price_details.currency_symbol}})</span></span> -->
            </label>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
/* eslint-disable */
import { utilsMixin } from '../mixins/utils.js'
export default {
  mixins: [utilsMixin],
  name: 'ProductOptions',
  components: {

  },
  props: {
    currentProductInPopup: Array
  },
  data () {
    return {

    }
  },
  mounted() {

  },
  created () {
    
  },
  methods: {
    updateCategories (opId, valId) {
      this.$emit('updateCategories', opId, valId);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .mobile {
    .options__wrapper {
      padding-bottom: 0;
      .option {
        .minMax {
          background: transparent;
          border: 0;
          padding: 0;
        }
        .options {
          button {
            margin-bottom: 10px;
            min-height: auto;
            padding: 0px;
            border-radius: 10px;
            overflow: hidden;
            .opt_photo {
              height: 100px;
              @media screen and (max-width: 420px) {
                // height: 70px;
              }
            }
          }
          &.withPhoto {
            margin-left: -10px;
            margin-right: -10px;
          }
          .withPhoto {
            width: calc(33.33% - 20px);
            margin-right: 10px;
            margin-left: 10px;
            @media screen and (max-width: 420px) {
              width: calc(50% - 20px);
            }
          }
          &>div {
            margin-right: 10px;
          }
        }
        @media screen and (max-width: 400px) {
          .optionTitle {
            flex-direction: column;
            align-items: flex-start;
            .minMax {
              margin: 0;
              margin-top: 5px;
            }
          }
        }
      }
    }
  }
  .comp_39 {
    .options__wrapper {
      .option {
        .options {
          input:checked ~ button {
            background-color: #000;
          }
        }
      }
    }
  }
  .options__wrapper {
    display: flex;
    flex-direction: column;
    padding: 20px;
    z-index: 2;
    position: relative;
    p {
      font-size: 1.62rem;
      font-weight: 500;
      text-align: left;
      margin: 0;
      text-transform: uppercase;
    }
    .option {
      margin-bottom: 20px;
      .defaultOption {
        button {
          display: flex;
        }
      }
      .withPhoto {
        button {
          border: 0 !important;
          .name {
            min-height: 55px;
          }
          .price {
            font-weight: bold;
          }
        }
      }
      .optionTitle {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 10px;
      }
      .minMax {
        margin-left: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #EBEBEB;
        border: 1px solid #E3E3E3;
        border-radius: 10px;
        padding: 5px 15px;
        svg {
          margin-right: 5px;
        }
        span {
          font-size: 1.12rem;
          font-weight: 500;
        }
      }
      .options {
        display: flex;
        flex-wrap: wrap;
        button {
          border-radius: 15px;
          background: #fff;
          color: #000;
          border: 1px solid var(--principal);
          margin-bottom: 20px;
          padding: 10px 15px;
          min-height: 48px;
          width: 100%;
          &.disabled {
            opacity: 0.5;
          }
          .opt_photo {
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            width: 100%;
            height: 120px;
          }
        }
        .withPhoto {
          width: calc(25% - 20px);
          margin-right: 10px;
          margin-left: 10px;
        }
        input {
            opacity: 0;
            position: absolute;
        }
        input:checked ~ button {
          background-color: var(--principal);
          color: #fff;
          span {
            span {
              color: #fff;
            }
          }
        }
        >div {
          margin-right: 20px;
        }
        label {
          display: flex;
          align-items: center;
          justify-content: center;
          input {
            margin: 0;
          }
          span {
            font-size: 1.37rem;
            font-weight: 500;
            padding: 5px 10px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            span {
              font-size: 1.5rem;
              font-weight: 700;
              color: var(--principal);
            }
          }
        }
      }
    }
  }
  // .mobile .productModal .options__wrapper .option .options button {
  //   color: var(--iconsColor1);
  //   background: var(--iconsColor2);
  // }
  // .productModal .options__wrapper .option .options input:checked~button {
  //   color: var(--iconsColor2);
  //   background: var(--iconsColor1);
  // }
</style>
